export const SESSION_HEADER_NAME = 'X-Session-Timeout-Seconds';
export const DEFAULT_HOMEPAGE_URL = 'https://test.empatia.gov.pl/';
